import type { SupportContext, SupportKind } from '@/lib/schemas/support.schema';
import { toolLabel } from '@/lib/editor/toolLabels';
import type { EditorProbe } from './editorProbe';
import type { Collected } from './collector';

// ── Le contexte joint a une demande (R6) ──
// Une question ou une idee : le contexte leger (la page, la vue, l'etage, le projet, le navigateur et la version).
// Un probleme : tout (l'outil, la selection, l'enregistrement, les erreurs, les requetes, les actions, l'ordinateur),
// meme sans la copie du projet.

type Env = NonNullable<SupportContext['env']>;

/** Ce que le contexte lit hors de l'editeur (la page, l'ordinateur, le collecteur) ; simule dans les tests */
export interface ContextSources {
  page: { path: string; title: string };
  env: Env;
  collected: Collected;
}

export function buildContext(kind: SupportKind, probe: EditorProbe | null, sources: ContextSources): SupportContext {
  const floorName = probe?.activeFloorId ? probe.project.floors?.find(f => f.id === probe.activeFloorId)?.name : undefined;
  const page = {
    ...sources.page,
    ...(probe?.viewMode ? { view: probe.viewMode } : {}),
    ...(floorName ? { floorName } : {}),
  };
  if (kind !== 'BUG') {
    return {
      page,
      ...(probe ? { project: { id: probe.project.id, name: probe.project.name } } : {}),
      env: { userAgent: sources.env.userAgent, version: sources.env.version },
    };
  }
  const revision = probe?.revision;
  const savedRevision = probe?.savedRevision;
  return {
    page: {
      ...page,
      ...(probe?.activeTool ? { tool: toolLabel(probe.activeTool) } : {}),
      ...(probe?.selection ? { selection: { type: probe.selection.type, label: probe.selection.label } } : {}),
    },
    ...(probe ? {
      project: {
        id: probe.project.id, name: probe.project.name,
        ...(revision !== undefined ? { revision } : {}),
        ...(savedRevision !== undefined ? { savedRevision } : {}),
        ...(revision !== undefined && savedRevision !== undefined ? { dirtyCount: revision - savedRevision } : {}),
        ...(probe.lastSave ? { lastSaveAt: probe.lastSave.at, lastSaveOk: probe.lastSave.ok } : {}),
      },
    } : {}),
    errors: sources.collected.errors,
    requests: sources.collected.requests,
    trail: sources.collected.trail,
    env: sources.env,
  };
}
